import type { Event } from '../../types';
import { getClientName, getHasWarnings } from '../../utils';

export interface ChipPreviewData {
  width: number;
  isClient: boolean;
  isAbsent: boolean;
  isRecurring: boolean;
  hasWarnings: boolean;
  detailZoomLevel: number;
  label: string;
}

type ChipPreviewSource = Pick<
  Event,
  | 'activity'
  | 'clients'
  | 'warnings'
  | 'timeWindow'
  | 'isAbsent'
  | 'isRecurring'
>;

/**
 * Pre-compute the chip-preview data so the detached drag-preview tree is a pure
 * data -> markup transform with no Recoil/Redux/i18n provider access.
 */
export const buildChipPreviewData = (
  props: ChipPreviewSource,
  width: number,
  detailZoomLevel: number
): ChipPreviewData => {
  const isClient = props.activity?.clientRelatedType !== 'NON_CLIENT_RELATED';
  const clientName = getClientName(props.clients?.[0]) ?? 'Onbekend';
  const w = props.warnings ?? {};

  return {
    width,
    isClient,
    isAbsent: !!props.isAbsent,
    isRecurring: !!props.isRecurring,
    hasWarnings: getHasWarnings({
      startsTooEarly: !!w.startsTooEarly,
      startsTooLate: !!w.startsTooLate,
      isInSyncWithEcd: w.isInSync ?? true,
      excludedEmployeeClientCombination: !!w.excludedEmployeeClientCombination,
      isUrgent: !!props.timeWindow?.isUrgent,
      hasOverlap: !!w.hasOverlap
    }),
    detailZoomLevel,
    label: isClient ? clientName : props.activity?.name ?? '-'
  };
};
